import React, { PureComponent } from "react";
import moment from "moment";

import { TTP_HOME_URL, TTP_TALK_URL } from "Config";
import styles from "./Talk.local.scss";
import classnames from "classnames";
import _ from "i18n";

export const ROOM_TYPE_CLIENT = "client";
export const ROOM_TYPE_EMPLOYEE = "employee";

export const RT_KITCHEN = "w";
export const RT_DUO = "x";
export const RT_COMMUNITY = "v";
export const RT_HELPDESK = "h";
export const RT_SERVICE = "s";
export const RT_CAFETERIA = "a";

const timeAgo = date =>
  moment(date).calendar(null, {
    lastDay: `[${_("yesterday")}]`,
    sameDay: "H:mm",
    lastWeek: "dddd",
    sameElse: function(now) {
      const diff = Math.ceil(this.diff(now, "years", true));
      return diff < 0 ? "MMM D YYYY" : "MMM D";
    }
  });

export default class TalkComponent extends PureComponent {
  renderSkeletons() {
    return (
      <ul className={styles.content}>
        {[1, 2, 3, 4].map(key => (
          <li className={styles.item} key={key}>
            <div className={styles.avatar} />
            <div className={styles.chat}>
              <div
                className={`${styles.chatInfos} ${
                  styles["chatInfos--loading"]
                }`}
              />
              <p
                className={`${styles.chatMessage} ${
                  styles["chatMessage--loading"]
                }`}
              />
            </div>
          </li>
        ))}
      </ul>
    );
  }

  getRoomAvatarUrl(sub) {
    const path =
      sub.t === "d"
        ? encodeURIComponent(sub.name)
        : `room/${encodeURIComponent(sub.rid)}`;

    return `${TTP_TALK_URL}/avatar/${path}`;
  }

  getRoomUrl(sub) {
    let path = "";

    if (sub.t === "c") {
      path = `channel`;
    }

    if (sub.t === "d") {
      path = `direct`;
    }

    if (sub.t === "p") {
      path = `group`;
    }

    if (sub.t === RT_HELPDESK) {
      path = "helpdesk";
    }

    if (sub.t === RT_KITCHEN) {
      path = "kitchen";
    }

    if (sub.t === RT_DUO) {
      path = "duo";
    }

    if (sub.t === RT_SERVICE) {
      path = "service";
    }

    if (sub.t === RT_CAFETERIA) {
      path = "cafeteria";
    }

    if (sub.t === RT_COMMUNITY) {
      path = "community";
    }

    let url = `${TTP_TALK_URL}/${path}/${sub.name}`;

    if (sub.lastMessage) {
      url += `?msg=${sub.lastMessage._id}`;
    }

    return url;
  }

  renderRoomIcon(sub) {
    const { usersPresence } = this.props;

    if (sub.prid) {
      return <i className={"icon icon-bubble"} />;
    }

    if (sub.t === "d") {
      const status = usersPresence[sub.name] || "offline";
      return <i className={`${styles[status]}`} />;
    }

    if (sub.t === "c") {
      return (
        <i className={styles.iconHash}>
          <svg id="icon-hashtag" viewBox="0 0 20 20" fill="currentColor">
            <path d="M5.71428571,12.5714286 L5.71428571,7.42857143 L2.85714286,7.42857143 C2.38375593,7.42857143 2,7.0448155 2,6.57142857 L2,6.57142857 C2,6.09804164 2.38375593,5.71428571 2.85714286,5.71428571 L5.71428571,5.71428571 L5.71428571,2.85714286 C5.71428571,2.38375593 6.09804164,2 6.57142857,2 L6.57142857,2 C7.0448155,2 7.42857143,2.38375593 7.42857143,2.85714286 L7.42857143,5.71428571 L12.5714286,5.71428571 L12.5714286,2.85714286 C12.5714286,2.38375593 12.9551845,2 13.4285714,2 L13.4285714,2 C13.9019584,2 14.2857143,2.38375593 14.2857143,2.85714286 L14.2857143,5.71428571 L17.1428571,5.71428571 C17.6162441,5.71428571 18,6.09804164 18,6.57142857 L18,6.57142857 C18,7.0448155 17.6162441,7.42857143 17.1428571,7.42857143 L14.2857143,7.42857143 L14.2857143,12.5714286 L17.1428571,12.5714286 C17.6162441,12.5714286 18,12.9551845 18,13.4285714 L18,13.4285714 C18,13.9019584 17.6162441,14.2857143 17.1428571,14.2857143 L14.2857143,14.2857143 L14.2857143,17.1428571 C14.2857143,17.6162441 13.9019584,18 13.4285714,18 L13.4285714,18 C12.9551845,18 12.5714286,17.6162441 12.5714286,17.1428571 L12.5714286,14.2857143 L7.42857143,14.2857143 L7.42857143,17.1428571 C7.42857143,17.6162441 7.0448155,18 6.57142857,18 L6.57142857,18 C6.09804164,18 5.71428571,17.6162441 5.71428571,17.1428571 L5.71428571,14.2857143 L2.85714286,14.2857143 C2.38375593,14.2857143 2,13.9019584 2,13.4285714 L2,13.4285714 C2,12.9551845 2.38375593,12.5714286 2.85714286,12.5714286 L5.71428571,12.5714286 Z M7.42857143,12.5714286 L12.5714286,12.5714286 L12.5714286,7.42857143 L7.42857143,7.42857143 L7.42857143,12.5714286 Z" />
          </svg>
        </i>
      );
    }

    return <i className={"icon icon-lock"} />;
  }

  renderBadge(sub) {
    if (sub.t === "p" || sub.t === "c") {
      return;
    }

    if (sub.t === "d" && sub.ttpType !== ROOM_TYPE_CLIENT) {
      return;
    }

    let label = "";

    if (sub.t === "d" && sub.ttpType === ROOM_TYPE_CLIENT) {
      label =
        sub.ttpClient && (sub.ttpClient.abbreviation || sub.ttpClient.name);
    }

    if (sub.t === RT_HELPDESK) {
      label = "Help Desk";
    }

    if (sub.t === RT_KITCHEN) {
      label = "Kitchen";
    }

    if (sub.t === RT_DUO) {
      label = "Duo";
    }

    if (sub.t === RT_SERVICE) {
      const serviceName = sub.ttpService && sub.ttpService.name;

      label = serviceName ? `Service (${serviceName})` : "Service";
    }

    if (sub.t === RT_CAFETERIA) {
      label = "Cafeteria";
    }

    if (sub.t === RT_COMMUNITY) {
      label = "Community";
    }

    return (
      <span className={`${styles.badge} ${styles["badge--" + sub.t]}`}>
        {label}
      </span>
    );
  }

  openRoom(sub) {
    setTimeout(() => {
      const roomUrl = this.getRoomUrl(sub);

      const $widget = $(`.talk-widget`);
      const $trigger = $widget.find(".talk-trigger");
      const iframe = $widget.find("iframe").get(0);

      const widgetOpened = $trigger.hasClass("talk-trigger--active");

      if (!widgetOpened) {
        $trigger.click();
      }

      if (iframe && iframe.contentWindow) {
        const data = {
          url: roomUrl,
          eventName: "talk:open-url"
        };
        iframe.contentWindow.postMessage(data, "*");
      }
    });
  }

  renderMessage(sub) {
    const { lastMessage } = sub;

    if (!lastMessage) {
      return _("No messages yet");
    }

    if (lastMessage.t === "e2e" && lastMessage.e2e !== "done") {
      return "******";
    }

    if (lastMessage.t === "talk_call") {
      return _("A call started");
    }

    if (!lastMessage.msg) {
      return _("Attachment sent");
    }

    return lastMessage.msg;
  }

  renderConnectionState() {
    const { connectionState, subscriptions, error } = this.props;

    if (error || !subscriptions || subscriptions.length === 0) {
      return;
    }

    if (connectionState === "DISCONNECTED") {
      return (
        <div className={styles.connectionState}>{_("Connecting ...")}</div>
      );
    }
  }

  renderSubscriptions() {
    const { subscriptions, error, onReload } = this.props;

    if (error) {
      return (
        <div className={styles.error}>
          <span>{_("Something went wrong")}</span>
          <button className={styles.tryAgain} onClick={() => onReload()}>
            <i className="icon-reload" /> {_("Try again")}
          </button>
        </div>
      );
    }

    if (!subscriptions || subscriptions.length === 0) {
      return <div className={styles.noMessages}>{_("No messages yet")}</div>;
    }

    return (
      <ul className={styles.content}>
        {subscriptions.map(sub => {
          return (
            <li className={styles.item} key={sub._id}>
              <a
                className={styles.link}
                onClick={() => this.openRoom(sub)}
                target="_blank"
              >
                <div
                  className={styles.avatar}
                  style={{
                    backgroundImage: `url("${this.getRoomAvatarUrl(sub)}")`
                  }}
                >
                  {this.renderRoomIcon(sub)}
                </div>
                <div className={styles.chat}>
                  {this.renderBadge(sub)}
                  <div className={styles.chatInfos}>
                    <h4>{sub.fname || sub.name}</h4>
                    <span>
                      {sub.lastMessage &&
                        sub.lastMessage.ts &&
                        timeAgo(sub.lastMessage.ts)}
                    </span>
                  </div>
                  <div className={styles.messageContainer}>
                    <p
                      className={`${styles.chatMessage} ${
                        sub.unread > 0 ? styles.chatMessageUnread : ""
                      }`}
                    >
                      {this.renderMessage(sub)}
                    </p>
                    {sub.unread > 0 && (
                      <span className={styles.unreadBadge}>
                        {sub.unread > 9 ? "9+" : sub.unread}
                      </span>
                    )}
                  </div>
                </div>
              </a>
            </li>
          );
        })}
      </ul>
    );
  }

  render() {
    const { loading, subscriptions, onReload } = this.props;
    let unread = 0;

    if (!loading && subscriptions && subscriptions.length > 0) {
      unread = subscriptions.reduce((acc, curr) => acc + curr.unread, 0);
    }

    return (
      <div className={styles.talk}>
        <div className={styles.header}>
          <span className={styles.title}>{_("Your conversations")}</span>
          {unread > 0 && (
            <div className={styles.unread}>
              {`${_("Unread")} (${unread > 99 ? "99+" : unread})`}
            </div>
          )}
          <div className={styles.app}>
            <span>Talk</span>
          </div>
        </div>
        {this.renderConnectionState()}
        {loading ? this.renderSkeletons() : this.renderSubscriptions()}
      </div>
    );
  }
}

// Conn



// WEBPACK FOOTER //
// ./src/components/Community/ClientSpace/Talk/TalkComponent.js